import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const itemLookupApi = (itemName: string) => axios.create({
  baseURL: API_BASE_URL + "api/itemlookup/" + itemName.toLowerCase(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
